var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Schema, type, MapSchema, ArraySchema } from "@colyseus/schema";
import { Player } from "./Player.js";
import { ChatMessage } from "./ChatMessage.js";
/**
 * Authoritative state for a LobbyRoom. The server mutates these collections;
 * Colyseus diffs and broadcasts changes to all connected clients each tick.
 *
 * `chat` is intended to be capped to CHAT_HISTORY_CAP entries by the server.
 */
export class LobbyState extends Schema {
    constructor() {
        super(...arguments);
        this.players = new MapSchema();
        this.chat = new ArraySchema();
        // True once the token economy is live (a launch mint is configured): chat
        // write then requires a connected wallet. False pre-launch = chat open to
        // all. Lets the client match the server's gate instead of guessing.
        this.chatGated = false;
    }
}
__decorate([
    type({ map: Player })
], LobbyState.prototype, "players", void 0);
__decorate([
    type([ChatMessage])
], LobbyState.prototype, "chat", void 0);
__decorate([
    type("boolean")
], LobbyState.prototype, "chatGated", void 0);
//# sourceMappingURL=LobbyState.js.map